import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlugin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"plugin-1, power, adapter"} maskId="square-filled-radius-0-stroke-1-IconPlugin1"><path d="M16 2H15L15 6H9L9 2H8L8 6H4V14.5C4 16.9853 6.01472 19 8.5 19H11.5V22H12.5V19H15.5C17.9853 19 20 16.9853 20 14.5L20 6H16L16 2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPlugin1;
